<template>
  <div class="notification-wrapper">
    <Notification v-for="notification in notifications" @closeNotification="closeNotification" :key="notification.MessageId" :notification="notification">
    </Notification>
  </div>
</template>

<script>
import Pusher from 'pusher-js';
import Notification from '@/components/Notification.vue';
import { pushPendingNotifications, markAsRead } from '@/api/notifications';

export default {
  name: 'Notifications',
  components: {
    Notification,
  },
  props: {
    authToken: {
      type: String,
    },
    userId: {
      type: Number,
    },
    brandId: {
      type: String,
    },
    brandName: {
      type: String,
    },
    pusherKey: {
      type: String,
    },
    pusherRegion: {
      type: String,
      default: 'eu',
    },
    prismaUrl: {
      type: String,
      default: '',
    },
    fusionUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pusher: null,
      channelName: '',
      channel: null,
      notifications: [],
    };
  },

  methods: {
    closeNotification(messageId) {
      const notificationIndex = this.notifications
        .findIndex(notification => notification.MessageId === messageId);

      if (notificationIndex > -1) {
        this.notifications.splice(notificationIndex, 1);
      }
    },
    onMessage(data) {
      console.log('Message', data, this.channelName);
      this.notifications.push(data);
      if (!data.MessageId) {
        return;
      }

      this.markAsRead(data);
    },
    onConnected(data) {
      console.log(data, this.channelName);
    },
    onDisconnected(data) {
      console.log(data, this.channelName);
    },
    onSubscription(data) {
      console.log(data, this.channelName);
    },
    onSubscriptionSuccess(data) {
      console.log(data, this.channelName);
      this.getNotifications();
    },
    getNotifications() {
      pushPendingNotifications(this.prismaUrl, this.authToken).catch((err) => {
        console.log('error pushing pending notifications: ', err); // eslint-disable-line
      });
    },
    markAsRead(notification) {
      markAsRead(this.prismaUrl, this.authToken, notification.MessageId).catch((err) => {
        console.log('error marking notification as isRead: ', err); // eslint-disable-line
      });
    },
  },
  watch: {
    authToken() {
      if (this.authToken !== '' && this.prismaUrl !== '') {
        this.pusher = new Pusher(this.pusherKey, {
          channelAuthorization: {
            endpoint: `${this.fusionUrl}/external/pusher/${this.brandName}?authToken=${this.authToken}`,
          },
          cluster: this.pusherRegion,
          encrypted: true,
          enableStats: false,
        });
      }
    },
    pusher() {
      // let channelName = `private-prisma-${settings.brand}`;
      // if (settings && settings.userId) {
      //   channelName += `-${settings.userId}`;
      // }

      this.channelName = `private-prisma-${this.brandId}-${this.userId}`;
      this.pusher.connection.bind('connected', data => this.onConnected(data));
      this.pusher.connection.bind('disconnected', data => this.onDisconnected(data));
      this.channel = this.pusher.subscribe(this.channelName);
      this.channel.bind('pusher:subscription_error', data => this.onSubscription(data));
      this.channel.bind('message', data => this.onMessage(data));
      this.channel.bind('pusher:subscription_succeeded', data => this.onSubscriptionSuccess(data));
    },
  },
};
</script>

<style lang="less" scoped>
.notification-wrapper {
  position: fixed;
  top: 40px;
  right: 40px;
  z-index: 10001;

  @media (max-width: 767px) {
    left: 40px;
  }
}
</style>
